/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Us_EnglishInputs */



/**
* | output |
* | --- |
* | "US English" |
*
* @param {Us_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const us_english = /** @type {((inputs?: Us_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Us_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anglais américain")
	if (locale === "de") return /** @type {LocalizedString} */ ("US-Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese americano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Американский английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inglés de EE. UU.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("美国英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アメリカ英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अमेरिकी अंग्रेजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês americano")
	return /** @type {LocalizedString} */ ("US English")
});